// ─── API BASE URL ───────────────────────────────────────────────────────────
// Two options — keep exactly ONE line active (the other commented out).
//
//   LOCAL DEVELOPMENT: uncomment the localhost line, comment the VPS line.
//     Then run:  cd front-end && npm start
//
//   VPS PRODUCTION BUILD: comment the localhost line, uncomment the VPS line.
//     Then run:  cd front-end && npm run build
//     Then upload the front-end/build folder to your web server.
// ─────────────────────────────────────────────────────────────────────────────

// ── LOCAL (development) ──
//const BaseURL = 'http://localhost:5002';

// ── VPS (production) ──
 const BaseURL = 'https://rpcgdb.yourcaresystem.online';

// ─── Setup / Church Settings ────────────────────────────────────────────────
export const setupStatusURL         = `${BaseURL}/setup/status`;
export const setupInitURL           = `${BaseURL}/setup/init`;
export const churchSettingsURL      = `${BaseURL}/church-settings`;
export const churchSettingsUpdateURL= `${BaseURL}/church-settings/update`;

// ─── Auth ───────────────────────────────────────────────────────────────────
export const authLoginURL           = `${BaseURL}/auth/login`;

// ─── Users ──────────────────────────────────────────────────────────────────
export const usersURL               = `${BaseURL}/users`;
export const usersAddURL            = `${BaseURL}/users/add`;
export const usersUpdateURL         = `${BaseURL}/users/update`;
export const usersDeleteURL         = `${BaseURL}/users/delete`;


// ─── Income Types ───────────────────────────────────────────────────────────
export const incomeTypesURL         = `${BaseURL}/income-types`;
export const incomeTypesAllURL      = `${BaseURL}/income-types/all`;
export const incomeTypesAddURL      = `${BaseURL}/income-types/add`;
export const incomeTypesUpdateURL   = `${BaseURL}/income-types/update`;
export const incomeTypesDeleteURL   = `${BaseURL}/income-types/delete`;

// ─── Income Categories ─────────────────────────────────────────────────────
export const incomeCategoriesURL       = `${BaseURL}/income-categories`;
export const incomeCategoriesAddURL    = `${BaseURL}/income-categories/add`;
export const incomeCategoriesUpdateURL = `${BaseURL}/income-categories/update`;
export const incomeCategoriesDeleteURL = `${BaseURL}/income-categories/delete`;

// ─── Expense Types ──────────────────────────────────────────────────────────
export const expenseTypesURL        = `${BaseURL}/expense-types`;
export const expenseTypesAllURL     = `${BaseURL}/expense-types/all`;
export const expenseTypesAddURL     = `${BaseURL}/expense-types/add`;
export const expenseTypesUpdateURL  = `${BaseURL}/expense-types/update`;
export const expenseTypesDeleteURL  = `${BaseURL}/expense-types/delete`;

// ─── Expense Categories ────────────────────────────────────────────────────
export const expenseCategoriesURL       = `${BaseURL}/expense-categories`;
export const expenseCategoriesAddURL    = `${BaseURL}/expense-categories/add`;
export const expenseCategoriesUpdateURL = `${BaseURL}/expense-categories/update`;
export const expenseCategoriesDeleteURL = `${BaseURL}/expense-categories/delete`;

// ─── Bank Accounts ──────────────────────────────────────────────────────────
export const bankAccountsURL        = `${BaseURL}/bank-accounts`;
export const bankAccountsAddURL     = `${BaseURL}/bank-accounts/add`;
export const bankAccountsUpdateURL  = `${BaseURL}/bank-accounts/update`;
export const bankAccountsDeleteURL  = `${BaseURL}/bank-accounts/delete`;

// ─── Weekly Cash (Income Entries) ───────────────────────────────────────────
export const weeklyCashURL          = `${BaseURL}/weekly-cash`;
export const weeklyCashSummaryURL   = `${BaseURL}/weekly-cash/summary`;
export const weeklyCashAddURL       = `${BaseURL}/weekly-cash/add`;
export const weeklyCashUpdateURL    = `${BaseURL}/weekly-cash/update`;
export const weeklyCashDeleteURL    = `${BaseURL}/weekly-cash/delete`;

// ─── Bank Deposits ──────────────────────────────────────────────────────────
export const bankDepositsURL        = `${BaseURL}/bank-deposits`;
export const bankDepositsAddURL     = `${BaseURL}/bank-deposits/add`;
export const bankDepositsUpdateURL  = `${BaseURL}/bank-deposits/update`;
export const bankDepositsDeleteURL  = `${BaseURL}/bank-deposits/delete`;

// ─── Payment Vouchers ───────────────────────────────────────────────────────
export const paymentVouchersURL     = `${BaseURL}/payment-vouchers`;
export const paymentVouchersNextURL = `${BaseURL}/payment-vouchers/next-pv`;
export const paymentVouchersByChequeURL = `${BaseURL}/payment-vouchers/by-cheque`;
export const paymentVouchersAddURL    = `${BaseURL}/payment-vouchers/add`;
export const paymentVouchersAddBatchURL = `${BaseURL}/payment-vouchers/add-batch`;
export const paymentVouchersUpdateURL = `${BaseURL}/payment-vouchers/update`;
export const paymentVouchersDeleteURL = `${BaseURL}/payment-vouchers/delete`;

// ─── Cash Book ──────────────────────────────────────────────────────────────
export const cashBookURL            = `${BaseURL}/cash-book`;
export const cashBookBalanceURL     = `${BaseURL}/cash-book/balance`;
export const cashbookSummaryURL     = `${BaseURL}/cashbook/summary`;

// ─── Reports ────────────────────────────────────────────────────────────────
export const reportIncomeStatementURL   = `${BaseURL}/reports/income-statement`;
export const reportTrialBalanceURL      = `${BaseURL}/reports/trial-balance`;
export const reportCashFlowURL          = `${BaseURL}/reports/cash-flow`;
export const reportReceiptsPaymentsURL  = `${BaseURL}/reports/receipts-payments`;
export const reportReceiptsLedgerURL    = `${BaseURL}/reports/receipts-ledger`;
export const reportPaymentsLedgerURL    = `${BaseURL}/reports/payments-ledger`;
export const reportBankStatementURL     = `${BaseURL}/reports/bank-statement`;
export const reportBankAnalysisURL      = `${BaseURL}/reports/bank-analysis`;
export const reportCashBookURL          = `${BaseURL}/reports/cash-book`;

// ─── Accounting Periods ─────────────────────────────────────────────────────
export const accountingPeriodsURL       = `${BaseURL}/accounting-periods`;
export const accountingPeriodsAddURL    = `${BaseURL}/accounting-periods/add`;
export const accountingPeriodsDeleteURL = `${BaseURL}/accounting-periods/delete`;
export const accountingPeriodsToggleURL = `${BaseURL}/accounting-periods/toggle`;

export default BaseURL;
